/* Progressive enhancement: without JavaScript the full introduction stays visible. */
if (!customElements.get('sd-collection-intro')) {
  customElements.define('sd-collection-intro', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const button = this.querySelector('.sd-collection-intro__toggle');
      if (!button) return;
      this.initialized = true;
      button.hidden = false;
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        button.querySelector('.sd-collection-intro__label').textContent = expanded ? 'Weniger anzeigen' : 'Mehr erfahren';
      });
    }
  });
}
